import _sfc_main from "./ProfileDropdownMenuItem.vue2.js";
/* empty css                             */
import _export_sfc from "../../_virtual/_plugin-vue_export-helper.js";
const ProfileDropdownMenuItem = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-f144f3ad"]]);
export {
  ProfileDropdownMenuItem as default
};
//# sourceMappingURL=ProfileDropdownMenuItem.vue.js.map
